import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import authReducers from '../reducers/authReducers';
import DetailReducers from '../reducers/detailsReducers';
import PlayReducers from '../reducers/PlayReducers'
import editReducers from '../reducers/editReducers'
import ScoreReducers from '../reducers/scoreReducers'
import resultReducers from '../reducers/resultReducers'

export default createStore(
    combineReducers({
        authReducers,
        DetailReducers,
        PlayReducers,
        editReducers,
        ScoreReducers,
        resultReducers
    }), {}, (applyMiddleware(thunk))
);


// WEBPACK FOOTER //
// ./src/store/store.jsx